import { createRoot } from 'solid-js'
import { createStore } from 'solid-js/store'

interface BreadcrumbState {
  crumbs: string[] | null
}

const [state, setState] = createRoot(() => createStore<BreadcrumbState>({ crumbs: null }))

/**
 * Miga de pan propia de una página: ej. la ficha de empresa pone
 * ['Empresas', 'Mi Empresa'] y el layout la muestra en vez de derivarla del
 * menú. Pasar `null` (o limpiar en `onCleanup`) vuelve a la derivación normal.
 */
export const setTrailOverride = (crumbs: string[] | null) => setState({ crumbs })
export const useTrailOverride = () => state.crumbs
